import React, { useCallback, useState } from 'react';
import useWebSocketCaller from '../../../hooks/useWebSocketCaller';
import { useConfigPathContext } from '../../../providers/ConfigPathContextProvider';
import AreYouSure from './AreYouSure';
import Buffer56 from './Buffer56';
import FolderCommander from './FolderCommander';
import { useConfigStepsContext } from '../../../providers/ConfigStepsContextProvider';
import { cutSteps } from '../../../hooks/useSelector';
import './WizardFolderLabel.css';
//import { K_INFO, isMetaData, isFolder } from '../../../providers/ConfigsDataContextProvider';


const WizardFolderLabel = ({parentFolderPath, folderName, stepName, switchToEdit}) => {
  const {configPath, setConfigPath}                           = useConfigPathContext();
  const {configSteps, setConfigSteps}             = useConfigStepsContext();
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const {sendMessage}                             = useWebSocketCaller();

  //------ Confirm/Cancel  Delete  ------
  //
  const confirmDelete = useCallback(() => setShowConfirmDelete(true), []);
  const cancelConfirmDelete = useCallback(() => setShowConfirmDelete(false), []);

  //------  Delete Folder  ------
  //
  const submitDeleteFolder = useCallback(() => {
    sendMessage('delete-config-folder', {
      basePath: parentFolderPath,
      folderName: folderName
    });
  }, [sendMessage, parentFolderPath, folderName]);


  //------ Folder Clicked  ------
  //
  const onFolderClicked = useCallback(() => {    
    const selectedFolderPath = `${parentFolderPath}['${folderName}']`;
    cutSteps(configSteps, stepName); // TODO: Might be replaced with pathToSteps OR Check to remove, How does it helps when cutSteps modify directly the configSteps object but DO NOT apply it with setConfigSteps? the line below seems to apply the new configSteps but cutSteps doesn't seems permanent now.
    setConfigSteps(prev => ({...prev, [stepName]:folderName}));
    setConfigPath(selectedFolderPath);
  }, [parentFolderPath, folderName, configSteps, stepName, setConfigSteps, setConfigPath]);

  const myFolderPath = `${parentFolderPath}['${folderName}']`;
  const isActive = configPath.startsWith(myFolderPath);
  //console.log('[WizardFolderLabel IsActive] [myFolderPath: %s] [configPath: %s]', myFolderPath, configPath);
  const style = `wizardFolderLabelWrap ${isActive ? 'activeShade' : ''}`;

  return (
    <div className={style}>
      <FolderCommander confirmDelete={confirmDelete} editFolderName={switchToEdit}/>
      {showConfirmDelete && 
      <div>
        <AreYouSure hideMe={cancelConfirmDelete} applyMe={submitDeleteFolder}/>
        <Buffer56 />
      </div>
      }

      <div className='wizardFolderLabel' onClick={onFolderClicked}>
        {folderName}
      </div>
    </div>
  );
};

export default WizardFolderLabel;